import React from 'react';
import { TitleWrapper, Title } from './PageTitle.styles';

type OwnProps = React.PropsWithChildren<{
  className?: string;
  title: string;
}>;

export default function PageTitle({ title, className, children }: OwnProps) {
  return (
    <TitleWrapper className={className} data-testid="page-title">
      <Title>{title}</Title>
      {children}
    </TitleWrapper>
  );
}
